import './projecttitle.css';

export function Projecttitle(){
    return <>
        <h2 className="ausgewaehlteProjekte">Ausgewählte Projekte</h2>
    </>;
}